import type { BlockCMS, Product } from '@/types'
import Link from 'next/link'
import ImageOptimize from '../ImageOptimize'
interface ModuleBannerType {
  data: BlockCMS
  order: number
}
const ModuleBanner = ({ data, order }: ModuleBannerType) => {
  const layout1 = (e: Product[]) => {
    return (
      <div className='w-full'>
        {e.map((item, index) => {
          return (
            <Link
              href={item?.path ? item?.path : '/'}
              className='block w-full'
              key={index}
            >
              {item?.image ? (
                <ImageOptimize
                  src={item?.image}
                  alt=''
                  width='0'
                  height='0'
                  sizes='100%'
                  className='h-auto w-full'
                />
              ) : (
                ''
              )}
            </Link>
          )
        })}
      </div>
    )
  }
  const layout2 = (e: Product[]) => {
    return (
      <div className='grid w-full grid-cols-2 gap-5'>
        {e.map((item, index) => {
          return (
            <Link
              href={item?.path ? item?.path : '/'}
              className='block w-full'
              key={index}
            >
              {item?.image ? (
                <ImageOptimize
                  src={item?.image}
                  alt=''
                  width='0'
                  height='0'
                  sizes='100%'
                  className='h-auto w-full'
                />
              ) : (
                ''
              )}
            </Link>
          )
        })}
      </div>
    )
  }
  const layout3 = (e: Product[]) => {
    return (
      <div className='grid w-full grid-cols-3 gap-5'>
        {e.map((item, index) => {
          return (
            <Link
              href={item?.path ? item?.path : '/'}
              className='block w-full'
              key={index}
            >
              {item?.image ? (
                <ImageOptimize
                  src={item?.image}
                  alt=''
                  width='0'
                  height='0'
                  sizes='100%'
                  className='h-auto w-full'
                />
              ) : (
                ''
              )}
            </Link>
          )
        })}
      </div>
    )
  }

  return (
    <section
      id={data._id}
      className={`${data?.type} ${data?.hideBot ? '' : 'pb-[20px]'} ${
        'order-[' + (order + 1) + ']'
      } scroll-mt-[158px]`}
    >
      {data && data.cols === 1 ? layout1(data?.data) : ''}
      {data && data.cols === 2 ? layout2(data?.data) : ''}
      {data && data.cols === 3 ? layout3(data?.data) : ''}
    </section>
  )
}

export default ModuleBanner
